"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsPublisher = exports.useMetrics = void 0;
const metricsPublisher_1 = require("./metricsPublisher");
Object.defineProperty(exports, "useMetrics", { enumerable: true, get: function () { return metricsPublisher_1.useMetrics; } });
const katal_metrics_1 = require("@amzn/katal-metrics");
Object.defineProperty(exports, "MetricsPublisher", { enumerable: true, get: function () { return katal_metrics_1.Publisher; } });
